const userId = () => sessionStorage.getItem("session_userId");

export { userId };
